// å¨å±è®¾ç½®ä¸ä¸ªå¯ä¸ç¦»å±ç ctxï¼ç¨äºè®¡ç® isPointInPath
var offScreenCtx = null;
export function getOffScreenContext() {
    if (!offScreenCtx) {
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        offScreenCtx = canvas.getContext('2d');
    }
    return offScreenCtx;
}
//# sourceMappingURL=offscreen.js.map